// Module
var code = "<div id=\"users-device-size\" >\r\n    <div id=\"xs\" class=\"visible-xs\"></div>\r\n    <div id=\"sm\" class=\"visible-sm\"></div>\r\n    <div id=\"md\" class=\"visible-md\"></div>\r\n    <div id=\"lg\" class=\"visible-lg\"></div>\r\n</div>";
// Exports
module.exports = code;